import * as R from 'ramda';
import { HttpClient, JSON_STRING, MHTTPCL } from "../../../../services/http/http-client";
import { BOOKING_URL, MODIFICATION_URL } from "../booking-service";
import { relatedContactService } from "./related-contacts.service";
import { SETTINGS_URL } from '../../../../services/common-urls';
import { combineServiceMethods } from '../../../../global/service';

const ARTIST = 'artist';
const ARTIST_DETAILS_TAB_OVERVIEW_FREE_DATES = 'artist_details_tab_overview_free_dates';

const ARTIST_DETAILS_TAB_OVERVIEW = 'artist_details_tab_overview';
const SET_MAIN_CONTACT_ID = 'set_main_contact_id';
const ARTIST_DETAILS_TAB_ADDITIONAL_INFO = 'artist_details_tab_additional_info';
const ARTIST_DETAILS_TAB_ARTIST_DEFAULT = 'artist_details_tab_artist_defaults';
const ARTIST_DETAILS_TAB_ADDITIONAL_ARTIST_DEFAULTS = 'artist_details_tab_additional_artist_defaults';
const GET_ARTIST_CUSTOM_DATA = 'get_artist_custom_data';
const ARTIST_DETAILS_TAB_BOOKINGS = 'artist_details_tab_bookings';
const ARTIST_DETAILS_TAB_ICAL_WEB_LINKS = 'artist_details_tab_ical_web_links';
const ARTIST_DETAILS_TAB_ROUTING = 'artist_details_tab_routing';
const ARTIST_DETAILS_TAB_PLAYLIST = 'artist_details_tab_playlist';

const CREATE_INFO = 'create_info';
const RELATED_INFOS = 'related_infos';

const DELETE_INFO = 'delete_info';
const EDIT_INFO = 'edit_info';
export const RECORD_STRING = 'record', ARTIST_INFOS = 'artist_infos', ARTIST_ID = 'artist_id', BOOKING_ARTISTS = 'booking_artists', ArtistService = {
  findAllArtists: () => HttpClient.get(BOOKING_URL, {
    section: ARTIST
  }),
  initArtistFreeDates: () => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_OVERVIEW_FREE_DATES,
    output: JSON_STRING
  }),
  findArtistFreeDates: ({
    months,
    days,
    artistId
  }, options) => HttpClient.post(BOOKING_URL, {
    months,
    days,
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_OVERVIEW_FREE_DATES,
    artist_id: artistId,
    output: JSON_STRING
  }, options),

  // Artist Detail Tabs HTTP Requests

  findArtistOverview: ({
    artistId,
    cancelToken
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_OVERVIEW,
    artist_id: artistId,
    output: JSON_STRING,
    output: JSON_STRING
  }, options),
  findAdditionalInfo: ({
    artistId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_ADDITIONAL_INFO,
    artist_id: artistId,
    output: JSON_STRING
  }, options),
  findArtistDefaults: ({
    artistId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_ARTIST_DEFAULT,
    artist_id: artistId,
    output: JSON_STRING
  }, options),
  findAdditionalArtistDefaults: ({
    artistId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_ADDITIONAL_ARTIST_DEFAULTS,
    artist_id: artistId,
    output: JSON_STRING
  }, options),
  findArtistCustomData: ({
    artistId
  }, options) => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: GET_ARTIST_CUSTOM_DATA,
    artist_id: artistId,
    output: JSON_STRING
  }, options),
  findArtistBookings: ({
    artistId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_BOOKINGS,
    artist_id: artistId,
    output: JSON_STRING
  }, options),
  findNextArtistBookings: ({
    artistId,
    offset
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: 'retrieve_artist_booking_page',
    artist_id: artistId,
    startrow: offset,
    output: JSON_STRING
  }, options),
  findArtistICalLinks: ({
    artistId
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_ICAL_WEB_LINKS,
    artist_id: artistId,
    ical: 1,
    output: JSON_STRING
  }, options),
  findArtistMap: ({
    artistId,
    from_date,
    to_date
  }, options) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: ARTIST_DETAILS_TAB_ROUTING,
    artist_id: artistId,
    from_date,
    to_date,
    output: JSON_STRING
  }, options),
  findArtistPlaylist: ({
    artistId
  }, options) => {
    console.log(options);
    return HttpClient.get(BOOKING_URL, {
      section: ARTIST,
      action: ARTIST_DETAILS_TAB_PLAYLIST,
      artist_id: artistId,
      output: JSON_STRING
    }, options)
  },

  // ---- End Tab requsts

  findRelatedInfos: ({
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: RELATED_INFOS,
    artist_id: artistId,
    output: JSON_STRING
  }),

  insertRelatedInfo: ({
    artistId,
    infoName,
    infoTxt
  }) => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: CREATE_INFO,
    artist_id: artistId,
    artist_info_name: infoName,
    info_txt: infoTxt
  }),
  getRelatedInfo: ({
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: RELATED_INFOS,
    artist_id: artistId
  }),
  deleteRelatedInfo: ({
    artistInfoId
  }) => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: DELETE_INFO,
    artist_info_id: artistInfoId
  }),
  editInfo: ({
    artistInfoId,
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: ARTIST,
    action: EDIT_INFO,
    artist_info_id: artistInfoId,
    artist_id: artistId
  }),
  modifyInfo: ({
    artistInfoId,
    infoName,
    infoText
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    kVal: artistInfoId,
    table: ARTIST_INFOS,
    artist_info_name: infoName,
    info_txt: infoText
  }),



  setMainContactId: ({
    contactId,
    artistId
  }) => HttpClient.post(BOOKING_URL, {
    section: ARTIST,
    action: SET_MAIN_CONTACT_ID,
    main_contact_id: contactId,
    artist_id: artistId
  }),


  removeUserFromArtist: ({
    artistId,
    userId
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'add_remove_user',
    artist_id: artistId,
    user_id: userId
  }),

  addUserToArtist: ({
    artistId,
    users
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'add_user_of_artist',
    artist_id: artistId,
    user_ids: users.map(e => e.user_id).join(','),
    checked_user_ids: users.map(e => 1).join(',')
  }),


  findCountries: ({
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'new_country',
    artist_id: artistId
  }),
  insertCountry: ({
    country,
    notes,
    artistId
  }) => HttpClient.post(BOOKING_URL, {
    country,
    notes,
    section: 'artist',
    action: 'create_country',
    artist_id: artistId,
    output: JSON_STRING
  }),
  removeCountry: ({
    artistCountryId
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'delete_country',
    artist_country_id: artistCountryId
  }),

  modifyBookingArtist: ({
    artistId,
    name,
    value
  }) => HttpClient.modify(
    ARTIST_ID,
    artistId,
    name,
    value,
    BOOKING_ARTISTS
  ),
  modifyCustomData: ({
    name,
    value,
  }) => HttpClient.post(MODIFICATION_URL, {
    kVal: name,
    name: 'data',
    value,
    table: 'custom_data'
  }),
  insertCustomData: ({
    fieldLabel
  }) => HttpClient.post(SETTINGS_URL, {
    section: 'bsettings',
    action: 'add_custom_field',
    field_label: fieldLabel,
    external_table: 'artist'
  }),
  filterArtistBookingList: ({
    artistId,
    month,
    location,
    city,
    partner,
    promoter
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'filter_artist_booking_list',
    artist_id: artistId,
    month,
    location,
    city,
    partner,
    promoter,
  }),

  createICalLink: ({
    artistId,
    icalParams
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'get_checksum',
    artist_id: artistId,
    ical_params: icalParams
  }),

  addTrack: ({
    artistId
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'add_track',
    booking_artist_id: artistId,
    output: JSON_STRING
  }),
  deleteTrack: ({
    bookingArtistTrackId
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'delete_artist_track',
    booking_artist_track_id: bookingArtistTrackId
  }),


  searchArtist: ({
    searchString
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'search_artist',
    search: searchString,
    tableID: 'artistsTable',
    output: JSON_STRING
  }),
  filterArtistByUser: ({
    userId
  }) => HttpClient.get(BOOKING_URL, {
    section: 'artist',
    action: 'filter_artists_by_user',
    user_id: userId
  }),
  createArtist: ({
    name,
    performanceType,
    url,
    language = ''
  }) => HttpClient.post(BOOKING_URL, {
    artist_name: name,
    performance_type: performanceType,
    url1: url,
    action: 'new_artist',
    section: 'artist',
    language: language,
    output: JSON_STRING
  }),
  deleteArtist: ({
    artistId
  }) => HttpClient.post(BOOKING_URL, {
    section: 'artist',
    action: 'delete_artist',
    artist_id: artistId
  }),

  addExternalCalendarLink: ({
    artist_id,
    description,
    external_link,
  }) => MHTTPCL.post(BOOKING_URL, {
    section: "artist",
    action: "add_external_link",
    output: JSON_STRING,
    artist_id,
    description,
    external_link,
  }).then(res => res.data),

  deleteExternalLink: ({
    external_link_id
  }) => MHTTPCL.post(BOOKING_URL, {
    section: "artist",
    action: "delete_external_link",
    external_link_id,
  }),

  //   section	"artist"
  // action	"get_artist_custom_data"
  // artist_id	"1397"

  ...relatedContactService
}


export const ArtistDetailsRequests = combineServiceMethods([
  'findArtistOverview',
  'findAdditionalInfo',
  'findArtistDefaults',
  'findAdditionalArtistDefaults',
  'findArtistCustomData',
  'findArtistBookings',
  'findArtistICalLinks',
  'findArtistMap',
  'findArtistPlaylist'
], ArtistService);